// Contains async/await fetch to data in Strapi (our CMS)
import { ref } from "vue";

const getStrapiDataSingle = (path) => {
  // Make reactive in template when used in setup()
  const strapiData = ref([]);
  const error = ref(null);
  const headers = {'Content-Type': 'application/json'};
  const load = async () => {
    try {
      const data = await fetch(process.env.VUE_APP_STRAPI_API + 'v1/'+ path + '?populate=*', {
        method: 'GET',
        headers: headers,
      }).then(checkStatus)
        .then(parseJSON);
      strapiData.value = data.data.attributes;
    } catch (err) {
      error.value = err.message;
      console.log(error.value);
    }
  };
  // Returns the ref'ed data and error as well as the load() function
  return { strapiData, error, load };
};

function parseJSON (resp) {
  return (resp.json ? resp.json() : resp);
};

function checkStatus (resp) {
  if (resp.status >= 200 && resp.status < 300) {
    return resp;
  }
  return this.parseJSON(resp).then((resp) => {
    throw resp;
  });
};


export default getStrapiDataSingle;
